import {
  MRT_ShowHideColumnsButton,
  MantineReactTable,
  useMantineReactTable,
} from 'mantine-react-table'
import { useLandingEventsTable } from './lib/use-landing-table'
import { useTranslation } from 'react-i18next'
import { getLocalization } from '@/widgets/LanguageSelect/lib/consts'

interface Props {
  currentUserId: number
}

export const LandingEventsTable = ({ currentUserId }: Props) => {
  const {
    pagination,
    numberOfLandingViews,
    columns,
    fetchedNotifications,
    isErrorNotifications,
    isFetchingNotifications,
    isLoadingNotifications,
    totalRowCount,
    sorting,
    setSorting,
    setPagination,
    columnFilters,
    setColumnFilters,
  } = useLandingEventsTable(currentUserId)
  const { i18n } = useTranslation()
  const localization = getLocalization(i18n.language)
  const { t } = useTranslation(['userManagement'])

  const table = useMantineReactTable({
    columns,
    data: fetchedNotifications,
    enableStickyHeader: false,
    enableColumnActions: false,
    manualPagination: true,
    onPaginationChange: setPagination,
    rowCount: totalRowCount,
    manualSorting: true,
    onSortingChange: setSorting,
    localization,
    enableRowActions: false,
    manualFiltering: true,
    onColumnFiltersChange: setColumnFilters,
    columnFilterDisplayMode: 'popover',
    enableColumnFilters: true,
    renderTopToolbar: ({ table }) => {
      return (
        <div className='flex flex-row items-center justify-between mb-2'>
          <div className='flex flex-row items-center space-x-2'>
            <div className='text-sm font-semibold'>
              {t('userManagement:landing_table.number_of_landing_views')}: {numberOfLandingViews}
            </div>
          </div>
          <div className='flex flex-row items-center space-x-2'>
            <MRT_ShowHideColumnsButton className='h-[2.5rem] w-[2.5rem] rounded-md' table={table} />
          </div>
        </div>
      )
    },
    mantinePaperProps: {
      shadow: 'none',
      withBorder: false,
    },
    mantineTableProps: {
      sx: {
        tableLayout: 'auto',
      },
    },
    mantineTableBodyProps: {
      sx: {
        '&: td': {
          minWidth: 90,
        },
        '& tr:hover': {
          backgroundColor: '#FFFFFF',
        },
      },
    },
    mantineTableBodyRowProps: {
      className: 'hover:bg-[#F4FAFD]/10',
    },
    state: {
      isLoading: isLoadingNotifications,
      pagination,
      sorting,
      columnFilters,
      showGlobalFilter: true,
      showAlertBanner: isErrorNotifications,
      showProgressBars: isFetchingNotifications,
    },
  })

  return <MantineReactTable table={table} />
}
